import { IGetChecklistMaquinaEquipItensByIdUseCase } from "../../../../controledePatrimonio/presentation/useCases/read/get_checklist_maquina_equip_itenss_by_id_use_case";
import { ChecklistMaquinaEquipItemModel } from "../../models/checklist_maquina_equip_item";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * GetChecklistMaquinaEquipItensByIdUseCase
 */

export class GetChecklistMaquinaEquipItensByIdUseCase implements IGetChecklistMaquinaEquipItensByIdUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async execute(
    idChecklistMaquinaEquip: number
  ): Promise<ChecklistMaquinaEquipItemModel> {
    const result = await this.repository.getChecklistMaquinaEquipItemById(idChecklistMaquinaEquip);
    return result;
  }
}
